
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/calendar","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#646e7e"}},[_c('path',{attrs:{"d":"M6.667 4.792a.625.625 0 01-.625-.625v-2.5a.625.625 0 01.625-.625.625.625 0 01.625.625v2.5a.625.625 0 01-.625.625z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.333 4.917a.75.75 0 01-.75-.75v-2.5a.75.75 0 01.75-.75.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17.084 8.2H2.917a.625.625 0 01-.625-.625.625.625 0 01.625-.625h14.167a.625.625 0 01.625.625.625.625 0 01-.625.625z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M6.667 2.292h6.667a4.738 4.738 0 013.634 1.35 4.891 4.891 0 011.157 3.442v7.083a4.891 4.891 0 01-1.157 3.446 4.738 4.738 0 01-3.635 1.346H6.667a4.738 4.738 0 01-3.635-1.346 4.891 4.891 0 01-1.157-3.446V7.084a4.89 4.89 0 011.157-3.442 4.738 4.738 0 013.635-1.35zm6.667 15.417a3.559 3.559 0 002.719-.946 3.7 3.7 0 00.823-2.6V7.084a3.7 3.7 0 00-.823-2.6 3.559 3.559 0 00-2.72-.942H6.667a3.559 3.559 0 00-2.719.946 3.7 3.7 0 00-.823 2.596v7.083a3.7 3.7 0 00.823 2.6 3.559 3.559 0 002.719.946z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.086 12.25h-.007a.833.833 0 110-1.667h.007a.833.833 0 010 1.667zM13.086 14.75h-.007a.833.833 0 110-1.667h.007a.833.833 0 010 1.667zM10.003 12.25h-.007a.833.833 0 110-1.667h.007a.833.833 0 010 1.667zM10.003 14.75h-.007a.833.833 0 110-1.667h.007a.833.833 0 010 1.667zM6.919 12.25h-.007a.833.833 0 110-1.667h.007a.833.833 0 010 1.667zM6.92 14.75h-.008a.833.833 0 01-.833-.834.833.833 0 01.833-.833h.007a.833.833 0 01.833.833.833.833 0 01-.832.834z","opacity":".4"}})])])
          )
        }
      }
    